var _path;
import * as React from "react";
function SvgChevronBoldUp(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.243 10.805l14.241 14.242c.687.686.687 1.8 0 2.487l-1.66 1.661a1.759 1.759 0 01-2.485.003l-11.34-11.287L8.66 29.197a1.758 1.758 0 01-2.484-.003l-1.66-1.66a1.759 1.759 0 010-2.488l14.241-14.241a1.759 1.759 0 012.487 0z"
  })));
}
export default SvgChevronBoldUp;